<!-- https://www.figma.com/file/reAk2sU4YpRajpQu2YBOHk/007%2F1.-%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B?type=design&node-id=165-23977&t=Sf11d7jBSxY9MSdr-0 -->
<template>
  <ContextMenu
    tag="span"
    handler-class="ref"
    :active="isPopupActive"
    :offset-y="3"
    :offset-x="0"
    @update:active="(value) => (isPopupActive = value)"
  >
    <TheContent
      v-for="child of children"
      :key="child.id"
      :elem="child"
    />

    <template #context>
      <div class="desktop ref-content">
        <TheContent
          v-for="child of refContent"
          :key="child.id"
          :elem="child"
        />
        <SvgAsset
          class="close"
          :path="closeSvg"
          @click="isPopupActive = false"
        />
      </div>
    </template>
    <template #mobile>
      <div class="ref-content">
        <TheContent
          v-for="child of refContent"
          :key="child.id"
          :elem="child"
        />
      </div>
    </template>
  </ContextMenu>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import ContextMenu from '@devhacker/shared/components/ContextMenu.vue';
  import SvgAsset from '@devhacker/shared/components/SvgAsset.vue';

  import TheContent from '~/components/content/TheContent';
  import type { RefAttributes } from '~/types/components/Ref';
  import closeSvg from '~/assets/images/close.svg';

  export default defineNuxtComponent({
    name: 'TheRef',

    components: {
      TheContent,
      ContextMenu,
      SvgAsset,
    },

    props: {
      elem: {
        type: Object as PropType<TContent<RefAttributes>>,
        required: true,
      },
    },

    data: () => ({
      isPopupActive: false,
    }),

    computed: {
      closeSvg: () => closeSvg,

      refContent(): TContent[] {
        return this.elem.attributes['data-template'];
      },

      children(): TContent[] {
        return this.elem.children;
      },
    },
  });
</script>

<style lang="scss" scoped>
  :deep(.ref.ref) {
    display: inline;
    cursor: pointer;
    border-bottom: 1px dashed;

    @include hover {
      color: var(--main-color-2);

      &:before {
        border-bottom-color: var(--main-color-2);
      }
    }
  }

  .ref-content {
    @include fontSmallTextBtn;

    & {
      position: relative;
      padding: 12px 16px 24px;
      overflow-wrap: break-word;
      font-weight: 400;
    }

    .close {
      position: absolute;
      top: 10px;
      right: 10px;
      height: 20px;
      width: 20px;
      cursor: pointer;
    }

    &.desktop {
      padding: 16px 44px 16px 20px;
      width: 320px;
      max-height: calc(100vh - 50px);
    }

    :deep() {
      ol {
        list-style-type: none;
        padding-left: 0;
        counter-reset: my-counter;
      }
      ol li {
        position: relative;
        padding-left: 24px;
        counter-increment: my-counter;
      }

      ol li::before {
        content: counter(my-counter) '.';
        position: absolute;
        left: 0;
        width: 16px;
        text-align: left;
      }
      ul {
        padding-left: 1em;
      }

      a {
        text-decoration: none;
        color: #2962f9;
        border-bottom: 2px solid transparent;

        @include hover {
          border-bottom-color: #2962f9;
        }

        &:visited {
          color: #7142d6;
          @include hover {
            border-bottom-color: #7142d6;
          }
        }
      }
    }
  }
</style>
